enum MakeModelChatType {
    BotMessage = 0,
    UserMessage = 1,
    Image = 2,
    Answers = 3,
    Question = 4,
    InfoMessage = 5,
    Submit = 6
}

export default MakeModelChatType;
